module.exports = __webpack_public_path__ + "static/img/s11.27c4ec43.png";